// extracted by mini-css-extract-plugin
export default {"main":"_49c0a5f95f _7cd010e43d","xmark":"_997b48dcb4","fl_img":"_8a338ec686 _5d02269367"};